import Config from "../Config";
import MetamodelStore from "../resources/data/MetamodelStore";
import Commons from "./Commons";
import { checkToken, isOauth } from "../_components/oauth/OAuth";
/**
 * Utils for sending requests
 */
class RequestHelper
{

    static arrayBufferToBase64 = (arrayBuffer) => {
        var binary = '';
        var bytes = new Uint8Array(arrayBuffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
    }
    /**
     * Get icons of elements
     * @param {String} sItemsType // elements type (object/model)
     */
    static getIcons = (sItemsType) =>
    {
        return new Promise((resolve, reject) =>
        {
            try
            {
                var aItems = null;
                switch (sItemsType)
                {
                    case 'model':
                        aItems = MetamodelStore.getInstance().getMetaModelTypes();
                        break;
                    case 'object':
                        aItems = MetamodelStore.getInstance().getMetaObjectTypesVisible();
                        break;
                }
                const aItemIds = Object.keys(aItems);
                if (aItemIds.length && 0 < aItemIds.length)
                {
                    for (var i = 0; i < aItemIds.length; i++)
                    {
                        var sID = aItemIds[i];
                        let sReqUrl = null;
                        switch (sItemsType)
                        {
                            case 'model':
                                sReqUrl = Commons.createGatewayRequestUrl(
                                {
                                    url: Config.anpRequestUrl.getMetaIconModeltype.replace(/%entity_id%/g, sID.substr(1, sID.length - 2)),
                                    dataType: "img"
                                });
                                break;
                            case 'object':
                                sReqUrl = Commons.createGatewayRequestUrl(
                                {
                                    url: Config.anpRequestUrl.getMetaIconClass.replace(/%entity_id%/g, sID.substr(1, sID.length - 2)),
                                    dataType: "img"
                                });
                                break;
                        }
                        var aCheckIcon;
                        try
                        {
                            aCheckIcon = MetamodelStore.getInstance().getIcon(sID);
                        }
                        catch (err)
                        {
                            aCheckIcon = null;
                        }
                        if ((Object.hasOwnProperty.call(aItems[sID], 'isSuper') && aItems[sID].isSuper) || aCheckIcon)
                        {
                            continue;
                        }

                        let aHeadersExtra = {
                            "Accept": "image/png"
                        };

                        const typeOfObject = isOauth() ? "buffer":"text";

                        RequestHelper.sendRequestCache(sReqUrl, typeOfObject, aHeadersExtra).then(((aParams, aData) =>
                        {

                            if(isOauth()){
                                var arrayBuffer = new Uint8Array(aData).buffer; // Example array buffer
                                var base64String = this.arrayBufferToBase64(arrayBuffer);
                                MetamodelStore.getInstance().setIcon(aParams.sID, base64String);
                            }else{
                                MetamodelStore.getInstance().setIcon(aParams.sID, aData);
                            }
                        }).bind(null,
                        {
                            sID: sID
                        }));
                    }
                    resolve();
                }
            }
            catch (err)
            {
                console.warn(err);
                reject();
            }
        });
    }

    /**
     * Sending requests
     * @param {String} sRequest // request URL
     * @param {String} sDataType // expected data type
     */
    static sendRequestCache = async (sRequest, sDataType, aHeadersExtra) =>
    {
        var parseData = async (aData) =>
        {

            // console.log('aData sendRequestCache',aData)

            try
            {
                switch (sDataType)
                {
                    case 'json':
                        return aData.json();
                        break;
                    case 'text':
                        return aData.text();
                        break;
                    case 'buffer':
                        return aData.arrayBuffer();
                        break;
                    default:
                        return aData.json();
                }
            }
            catch (error)
            {
                throw error;
            }
        }

        return new Promise(async (resolve, reject) =>
        {
            var aCache = await caches.open('wrc-cache');
            var aCachedData = await aCache.match(sRequest); // check cached data

            if (aCachedData && aCachedData.status == 200)
            {
                var aParsedData = await parseData(aCachedData);
                resolve(aParsedData);
            }
            else
            {
                let aHeaders = aHeadersExtra ||
                {};
                aHeaders["Authorization"] = Commons.getAuthHeaderToken();
                aHeaders["Accept-Language"] = Config.lang.selected;
                let aRequest = new Request(
                    sRequest,
                    {
                        method: "GET",
                        headers: aHeaders
                    }
                );
                aCache.add(aRequest).then(async () =>
                {
                    var aRequestedChachedData = await aCache.match(sRequest)
                    return aRequestedChachedData;
                }).then(async (aResponse) =>
                {
                    if (aResponse.status >= 400)
                    {
                        throw new Error(aResponse.status + ": Bad response from server");
                    }
                    var aParsedData = await parseData(aResponse);
                    resolve(aParsedData);
                });
            }
        }).catch(error =>
        {
            resolve(
            {
                isErr: true,
                message: (error && error.message) ? error.message : "Error occured"
            });
        });
    }

    static sendRequestSimple = async (aParams) =>
    {

        if(isOauth()){
            await checkToken()
            .then((result)=>{    
                if(!result){
                    return false;
                }
            })
    
        }

        let sRequest = aParams.request;
        const sDataType = aParams.dataType;
        let aHeaders = aParams.headers;
        const aBody = aParams.body;
        const sMethod = aParams.method;

        const aHeadersDefault = {
            "Authorization": Commons.getAuthHeaderToken(),
            "Accept-Language": Config.lang.selected
        };
        let aHeadersDefaultKeys = Object.keys(aHeadersDefault);
        if (!aHeaders)
        {
            aHeaders = {};
        }
        aHeadersDefaultKeys.forEach(sKey =>
        {
            if (!aHeaders.hasOwnProperty(sKey))
            {
                // console.log("key to add: " + sKey + ", value to add: " + aHeadersDefault[sKey]);
                aHeaders[sKey] = aHeadersDefault[sKey];
            }
        });

        if(sRequest.includes(Config.requestEngine)){
            sRequest = Config.requestEngine;
        }

        return new Promise(async (resolve, reject) =>
        {
            fetch(
                sRequest,
                {
                    method: sMethod ? sMethod : "GET",
                    headers: aHeaders ? aHeaders :
                    {},
                    body: aBody ? aBody : null
                }
            ).then(aResponse =>
            {
                if (aResponse.status === 401)
                {
                    throw new Error("401: unauthorized");
                }
                if (aResponse.status === 409)
                {
                    throw new Error("409: exists");
                }
                if (aResponse.status === 429)
                {
                    throw new Error("429: too many requests");
                }
                if (aResponse.status >= 400)
                {
                    throw new Error(aResponse.status + ": Bad response from server");
                }
                switch (sDataType)
                {
                    case "json":
                        return aResponse.json();
                        break;
                    case "text":
                        return aResponse.text();
                        break;
                    case "img":
                        return aResponse.arrayBuffer();
                        break;
                    default:
                        return aResponse.text();
                        break;
                }
            }).then(aData =>
            {
                resolve(aData);
            }).catch(aEx =>
            {
                console.error(aEx);
                resolve(
                {
                    isErr: true,
                    message: aEx.message
                });
            });
        }).catch(aEx =>
        {
            resolve(
            {
                isErr: true,
                message: aEx.message
            });
        });
    }
}

export default RequestHelper;